import {createContext, useContext, useEffect, useMemo} from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data);
    axios.defaults.headers.common["Authorization"] = "Bearer " + data.token;
    navigate("/dashboard");
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    delete axios.defaults.headers.common["Authorization"];
    navigate("/", { replace: true });
  };

  // useEffect(() => {
  //   if (user) {
  //     axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
  //   } else {
  //     delete axios.defaults.headers.common["Authorization"];
  //   }
  // }, [user]);

  const value = useMemo(
    () => ({
      user,
      login,
      logout
    }),[user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};